import React from 'react'

export const Button = ({className, title, type, onClick, ...props}) => {
    return (
        <button type={type} className={className} onClick={onClick} >{title}</button>
    )
}